export default [
  {
    id: 'auction',
    name: 'Parallel Auction',
  },
  {
    id: 'prioritize',
    name: 'Prioritize',
  },
];
